export function isStandaloneMode() {
  const navigatorWithStandalone = navigator as Navigator & { standalone?: boolean }
  return window.matchMedia('(display-mode: standalone)').matches || navigatorWithStandalone.standalone === true
}

export function isIosDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

export function initializePwaEnvironment() {
  const displayMode = window.matchMedia('(display-mode: standalone)')
  const syncClass = () => document.documentElement.classList.toggle('pwa-standalone', isStandaloneMode())
  syncClass()
  displayMode.addEventListener?.('change', syncClass)
}
